import ng from "angular";
import { AgGridService } from "@topline/services/agGridService";
import { angularServicesNames } from "@topline/services/angularServicesNames";
import { ForecastGridService } from "../services/forecastGridService";
import { Gen } from "../../../Services/api";

class ForecastHistoryComponentController {
    static $inject = [
        "$scope",
        ForecastGridService.componentName,
        angularServicesNames.$translate,
        AgGridService.componentName
    ];

    public historyItems: $TSFixMe[] = [];
    private gridApi: $TSFixMe;
    private forecastName: string;
    private serverOperation: ng.IPromise<Gen.ForecastHistoryDTO[]>;

    private close: $TSFixMe;
    private dismiss: $TSFixMe;
    private resolve: $TSFixMe;

    constructor(
        private $scope: ng.IScope,
        private forecastGridService: ForecastGridService,
        private $translate: ng.translate.ITranslateService,
        private agGridService: AgGridService
    ) {}

    public $onInit(): void {
        this.forecastName = this.resolve.name;
        this.serverOperation = this.forecastGridService.getHistory(this.resolve.forecastId).then(items => {
            this.historyItems = items;
            if (this.gridApi) {
                this.gridApi.setRowData(this.historyItems);
            }
            return items;
        });

        this.$scope.$on("LanguageChanged", () => this.agGridService.refreshGridLanguage(this.gridApi));
    }

    public ok(): void {
        this.close({ $value: "ok" });
    }

    public cancel(): void {
        this.dismiss({ $value: "cancel" });
    }

    public historyGridOptions = {
        columnDefs: [
            {
                headerValueGetter: () => this.$translate.instant("FORECAST_ACCEPTANCE.HISTORY.GRID.EVENT"),
                field: "type",
                valueFormatter: (params: $TSFixMe) => this.$translate.instant(params.data.type),
                tooltipValueGetter: (params: $TSFixMe) => params.valueFormatted
            },
            {
                headerValueGetter: () => this.$translate.instant("FORECAST_ACCEPTANCE.HISTORY.GRID.DATE"),
                field: "creationTime"
            },
            {
                headerValueGetter: () => this.$translate.instant("FORECAST_ACCEPTANCE.HISTORY.GRID.USER"),
                field: "user"
            }
        ],
        domLayout: "autoHeight",
        angularCompileRows: true,
        defaultColDef: {
            sortable: true,
            resizable: true
        },
        enableFilter: false,
        animateRows: true,
        localeTextFunc: this.agGridService.transalteFunc,
        suppressHorizontalScroll: true,
        onGridReady: (config: $TSFixMe) => {
            this.gridApi = config.api;
            config.api.sizeColumnsToFit();
            config.api.setRowData(this.historyItems);
        },
        onGridSizeChanged: (config: $TSFixMe) => {
            config.api.sizeColumnsToFit();
        }
    };
}

export class ForecastHistoryComponent implements ng.IComponentOptions {
    static componentName = "forecastHistory";
    bindings = {
        close: "&",
        dismiss: "&",
        resolve: "<"
    };
    controller = ForecastHistoryComponentController;
    template = require("./forecastHistory.component.html");
}

angular.module("topline.modules").component(ForecastHistoryComponent.componentName, new ForecastHistoryComponent());
